<template>
  <div>
    <v-row>
            <v-col>
                <v-tabs mr-5 dark color="#ffbc00" background-color="#01579b">
                    <v-tab class="font-weight-black">Notas Conductuales</v-tab>
                  
                    <v-tab-item>
                      <NotasConductuales class="mt-2" ></NotasConductuales>
                    </v-tab-item>

                </v-tabs>
            </v-col>
        </v-row>
    
  </div>
</template>

<script>
import NotasConductuales from './components/NotasConductuales.vue'


export default {
  components:{
    NotasConductuales
    },
}
</script>